var _g, _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHamburgerMenu = function SvgHamburgerMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M723.693 162.46h-679.386c-23.629 0-44.307-20.675-44.307-44.307s20.678-44.307 44.307-44.307h679.383c23.632 0 44.307 20.678 44.307 44.307s-20.675 44.307-44.304 44.307z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M723.693 428.308h-679.386c-23.629 0-44.307-20.678-44.307-44.31s20.678-44.307 44.307-44.307h679.383c23.632 0 44.307 20.678 44.307 44.307 0.003 23.632-20.675 44.31-44.304 44.31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M723.693 694.154h-679.386c-23.629 0-44.307-20.675-44.307-44.307s20.678-44.307 44.307-44.307h679.383c23.632 0 44.307 20.678 44.307 44.307s-20.675 44.307-44.304 44.307z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHamburgerMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburger-menu.333b93fa.svg";
export { ForwardRef as ReactComponent };